import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Instagram, Link2, CheckCircle2 } from "lucide-react";
import api from "../../lib/api";

export const photoUrl = (id, thumb) => `${process.env.REACT_APP_BACKEND_URL}/api/public/social/${id}${thumb ? ".thumb" : ""}.jpg`;

export function InstagramConnect() {
  const [s, setS] = useState(null);
  useEffect(() => {
    const p = new URLSearchParams(window.location.search).get("ig");
    if (p === "connected") toast.success("Instagram connected");
    if (p === "failed") toast.error("Instagram connection failed — try again");
    api.get("/social/instagram/status").then(({ data }) => setS(data)).catch(() => setS(null));
  }, []);
  const connect = async () => {
    try { const { data } = await api.get("/social/instagram/connect"); window.location.href = data.url; }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not start Instagram login"); }
  };
  if (!s) return null;
  if (s.connected) return (
    <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs text-emerald-800" data-testid="ig-connected">
      <CheckCircle2 className="h-3.5 w-3.5" /> Posting as @{s.account?.username}
    </div>
  );
  return (
    <div className="w-full min-w-0 rounded-xl border border-amber-200 bg-amber-50/60 px-4 py-3 text-sm text-amber-900 flex flex-wrap items-center gap-3" data-testid="ig-not-connected">
      <Instagram className="h-4 w-4" />
      {s.app_configured ? (
        <>
          <span>Instagram isn't connected yet — posts will wait until you connect.</span>
          <button onClick={connect} data-testid="ig-connect-btn" className="inline-flex items-center gap-1.5 rounded-full bg-brand-ink text-brand-page px-3 py-1 text-xs"><Link2 className="h-3 w-3" /> Connect Instagram</button>
        </>
      ) : (
        <span className="min-w-0 flex-1 break-words">Plan freely — auto-posting turns on once the Meta App ID/Secret are added (redirect URL: <code className="text-xs break-all">{s.redirect_uri}</code>).</span>
      )}
    </div>
  );
}
